import { getAppBaseUrl } from '@wix/wix-data-client-common/dist/esm/infra/getAppBaseUrl'

export default async editorSdkProxy => {
  if (process.env.JEST_WORKER_ID) {
    return
  }
  const appBaseUrl = await getAppBaseUrl(editorSdkProxy)
  __webpack_public_path__ = `${appBaseUrl}/` // eslint-disable-line
}
